import sdl from '@jds/react-generated-sdl/JDSDesktopBottomSheet';
import type { JDSDesktopBottomSheetProps } from './interface';

import { componentsMap } from '../../../generators/componentMap';
import {
  createComponent,
  getCustomJSON,
  useTokenValues
} from '@jds/react-engine';

import { withLogic, BottomSheetProps } from '../logic';

const Component = (props: BottomSheetProps) => {
  const { platform } = useTokenValues();

  const json = sdl;
  const {
    kind = 'overlay',
    controlType = 'normal',
    isCustom = false,
    close = true,
    primaryCtaDisabled = false,
    secondaryCtaDisabled = false,
    custom = '',
    ...rest
  } = props as any;
  return createComponent(
    json,
    {
      kind,
      controlType,
      isCustom,
      close,
      primaryCtaDisabled,
      secondaryCtaDisabled,
      ...rest
    },
    'JDSDesktopBottomSheet',
    componentsMap,
    getCustomJSON(custom || '') || {}
  );
};

const BottomSheet = withLogic(Component) as React.FC<BottomSheetProps> & {
  slotName?: string;
};

BottomSheet.displayName = 'BottomSheet';
BottomSheet.slotName = 'jds_desktop_bottom_sheet';

export { BottomSheet, type JDSDesktopBottomSheetProps };
